
// VIEW_TYPE_MOBILE размер окна для мобильных устройств 425 пикселей
export const VIEW_TYPE_MOBILE = 'mobile'

// VIEW_TYPE_TABLET размер окна для планшетов 768 пикселей
export const VIEW_TYPE_TABLET = 'tablet'

// VIEW_TYPE_DESKTOP размер окна для планшетов от 1024 пикселеля
export const VIEW_TYPE_DESKTOP = 'desktop'